import { render, staticRenderFns } from "./SimulatorDbPanel.vue?vue&type=template&id=13bf8d9b&scoped=true&"
import script from "./SimulatorDbPanel.vue?vue&type=script&lang=js&"
export * from "./SimulatorDbPanel.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorDbPanel.vue?vue&type=style&index=0&id=13bf8d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf8d9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
